export default {
    common: {
        email: 'بريد إلكتروني',
        LoginBtn: 'تسجيل الدخول',
        SignUpBtn: 'التسجيل',
        SubmitBtn: 'ُقدِّم',
        ExitBtn: 'تصدير',
        LogoutBtn: 'تسجيل الخروج'
    },
    login: {},
    login2FA: {
        pleaseCheckEmail: 'يرجى التحقق من بريدك الإلكتروني للحصول على رمز التحقق.',
        VerificationCode: 'رمز التحقق'
    },
    header: {
        OrderHistory: 'تاريخ الطلب',
        MYACCOUNT: 'حسابي',
        WelcomeBack: 'مرحبا بعودتك'
    },
    detail: {
        TotalOrders: 'إجمالي الطلبات',
        TotalProducts: 'إجمالي المنتجات',
        WonderlandPoints: 'نقاط بلاد العجائب',
        APMCredits: 'اعتمادات APM',
        ExpireOn: 'تاريخ الاستحقاق',
        NoAPMCredits: 'ا توجد اعتمادات APM',
        CreditsLoading: 'Credits loading',
        Orders: 'طلب',
        Online: 'عبر الإنترنت',
        Boutique: 'بوتيك',
        Total: 'المجموع',
        Delivered: 'تم التوصيل',
        NoData: 'لا توجد بيانات',
        Status: 'الحالة',
        item: 'البند',
        items: 'البنود'
    },
    panel: {},
    entry: {
        Client: 'العملاء',
        OrderDate: 'تاريخ الطلب',
        DeliverDate: 'تاريخ التسليم',
        Description: 'إيضاحات',
        Total: 'المجموع'
    },
    board: {
        Order: 'أمر',
        Date: 'تواريخ',
        Total: 'المجموع'
    },
    order: {
        OrderID: 'معرف الطلب',
        PurchasePlace: 'موقع',
        PurchaseDate: 'تاريخ الشراء',
        TotalPrice: 'السعر الإجمالي',
    },
    product: {
        Name: 'اسم',
        SKU: 'رمز التخزين التعريفي',
        Size: 'مقاس',
        Quantity: 'كمية',
        Price: 'سعر',
        WarrantyUntil: 'الضمان حتى',
    },
    ordersLayout: {
            pageTitleOrders: "الطلبات",
            wonderlandPointsBrand: "WONDERLAND POINTS",
            navHomepage: "الرئيسية",
            navProfile: "الملف الشخصي",
            navOrders: "الطلبات",
            navWonderland: "Wonderland",
            navWishlist: "قائمة الأمنيات",
            navContactUs: "اتصل بنا",
            navExchangeReturn: "الاستبدال والإرجاع",
            footerExchangePolicy: "سياسة الاستبدال والإرجاع",
            footerShipping: "الشحن",
            footerPrivacy: "سياسة الخصوصية",
            footerTerms: "شروط الخدمة",
            footerRegion: "فرنسا",
            menuTrackOrder: "تتبع الطلب",
            menuViewDetails: "عرض التفاصيل",
            back: "رجوع",
            orderNumberHeading: "رقم الطلب {{id}}",
            itemsCount_one: "{{count}} عنصر",
            itemsCount_other: "{{count}} عناصر",
            emptyOrders: "ليس لديك أي طلبات بعد.",
            loading: "جار التحميل",
            invoiceSoon: "قريبًا",
            storeAddressPending: "العنوان لاحقًا",
            skuPrefix: "SKU",
            statusLabel: "الحالة",
            productNameFallback: "منتج",
            tabOnline: "عبر الإنترنت",
            tabOffline: "غير متصل",
            learnMore: "اعرف المزيد",
            redeemInStore: "الاسترداد في المتجر",
            dateLabel: "التاريخ",
            itemSingular: "العنصر",
            statusConfirmed: "تم التأكيد في",
            purchaseDateLabel: "تاريخ الشراء:",
            monthJan: "يناير",
            monthFeb: "فبراير",
            monthMar: "مارس",
            monthApr: "أبريل",
            monthMay: "مايو",
            monthJun: "يونيو",
            monthJul: "يوليو",
            monthAug: "أغسطس",
            monthSep: "سبتمبر",
            monthOct: "أكتوبر",
            monthNov: "نوفمبر",
            monthDec: "ديسمبر",
            storeLabel: "المتجر",
            downloadInvoice: "تنزيل الفاتورة",
            warrantyExpires: "ينتهي الضمان في",
            sizeLabel: "المقاس",
            subtotalLabel: "المجموع الفرعي",
            totalLabel: "الإجمالي",
            ecListTitle: "طلباتك",
            ecStatusInStore: "الحالة: شراء من المتجر",
            ecOrderNumber: "رقم الطلب: {{order_number}}",
            ecDateStore: "{{date}} · {{store_name}}",
            ecCountTotalOne: "عدد المنتجات: {{count}} – الإجمالي: {{amount}}",
            ecCountTotalOther: "عدد المنتجات: {{count}} – الإجمالي: {{amount}}",
            ecViewOrder: "عرض الطلب >",
            ecViewOrderA11y: "عرض الطلب {{order_number}}",
            ecBackToOrders: "العودة إلى طلباتك",
            ecInStoreDate: "شراء من المتجر – {{date}}",
            ecProductsOne: "المنتج",
            ecProductsOther: "المنتجات",
            ecSku: "المرجع: {{sku}}",
            ecQty: "الكمية: {{qty}}",
            ecWarrantyExpired: "خارج فترة الضمان",
            ecWarrantyActive: "ضمن فترة الضمان",
            ecSubtotalOne: "المجموع الفرعي – عدد المنتجات: {{count}}",
            ecSubtotalOther: "المجموع الفرعي – عدد المنتجات: {{count}}",
        },
}



// WEBPACK FOOTER //
// ./src/locales/ar/index.js